/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsCompanyOutletsCtrl
 */
angular.module('mercury.modules.settings.company')
.controller('SettingsCompanyOutletsCtrl', ["Outlets", "$scope", "$stateParams", "dialog", "userinfo", function(Outlets, $scope, $stateParams, dialog, userinfo) {
  userinfo.activeCompany($stateParams.id);
  $scope.outletList = {};

  $scope.outletList = Outlets.get();
  $scope.loading = $scope.outletList.$promise;

  $scope.canDelete = function() {
    return $scope.outletList.length > 1;
  };

  $scope.addOutlet = function() {
    var modalInstance = dialog.open({
      templateUrl: 'modules/settings/company/outletsadd.tpl.html',
      controller: 'SettingsCompanyOutletsAddCtrl',
      size: 'lg',
      resolve: {
        companyId: function() {
          return $stateParams.id;
        }
      }
    });

    modalInstance.then(function(addedOutlet) {
      if (typeof(addedOutlet != 'undefined')) {
        addedOutlet.companyId = $stateParams.id;
        $scope.outletList.push(addedOutlet);
      }
    });
  };

  $scope.removeOutlet = function(outlet) {
    Outlets.delete(outlet).then(function() {
      var index = $scope.outletList.indexOf(outlet);
      $scope.outletList.splice(index, 1);
    });
  };
}]);
